import hand from './hand.svg';
import headband from './headband.svg';
import diode from './diode.svg';

export const handPhoto = () => hand;
export const headbandPhoto = () => headband;
export const diodePhoto = () => diode;
